<template>
    <el-dialog :visible.sync="dialogVisible" custom-class="is-align-center csd-dialog open_dialog un-border" width="474px"
        :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false">
        <div class="centerPanel">
            <div class="aside">
                <div class="advantage" v-for="ad in advantages"><i class="el-icon-check"></i>{{ ad }}</div>
            </div>
            <div class="con">
                <div class="top_right">
                    <div class="issue" @click="handleShowQuestion"><i class="el-icon-info"></i> 常见问题</div>
                    <div style="margin: 0 5px 0 10px;">|</div><i class="el-icon-close" @click="close"></i>
                </div>
                <div class="full">
                    <div class="user_info">
                        <img class="avatar"
                            :src="userInfo.avatarurl ? userInfo.avatarurl : '/static/img/default-avatar.png'" alt="">
                        <div class="info_right">
                            <div class="user_name">田昆</div>
                            <div class="info_detail">普通用户 <span style="margin: 0 3px;">|</span> 到期时间：2024-07-15</div>
                        </div>
                    </div>
                    <div class="vip_tab">
                        <div class="vip_tab_item" flex-center :class="active_vip_tab == index ? 'active' : ''" @click="choose_tab(index)"
                            v-for="(item, index) in vip_tab" :key="index">{{ item.title }}</div>
                    </div>
                    <div class="tab_con">
                        <div :class="['vip_list',{'active':payVip.id==item.id}]" v-for="(item, index) in vip_list" :key="index">
                            <div class="name">{{ item.name }}</div>
                            <div class="tips">{{ item.tips }}</div>
                            <div class="price">
                                <div class="quarter_price">￥{{ item.quarter_price }}元/季</div>
                                <div class="month_price">仅需￥{{ item.month_price }}/月</div>
                            </div>
                            <div class="split_line"></div>
                            <div class="vip_desc">
                                <div class="vip_desc_item" v-for="(item2, index2) in item.desc" :key="index2"><i></i>
                                    <p v-html="item2"></p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="pay_bottom">
                        <div class="pay_code">
                            <canvas class="code_img" id="canvas"></canvas>
                            <div v-if="timerout" class="time_out_cover" flex-center @click="getPayInfo"> <i class="el-icon-refresh-right"></i>重新获取 </div>
                        </div>
                        <div class="pay_right">
                            <div class="pay_money">实付：<span class="money_count">￥{{ payVip.quarter_price }}</span></div>
                            <div class="pay_tips"><img class="wx_icon" src="./img/weixin.png" alt=""> 请使用微信扫描二维码完成支付 </div>
                            <div class="agreement"> 支付视为您同意<a href="">《Midjourney会员服务协议》</a></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import QRCode from 'qrcode'
export default {
    data() {
        return {
            dialogVisible: false,
            advantages: [
                "充值积分永不过期",
                "MMJ绘画所有功能及风格模型",
                "充值积分永不过期",
                "MMJ绘画所有功能及风格模型",
                "充值积分永不过期",
                "MMJ绘画所有功能及风格模型",
                "充值积分永不过期",
                "MMJ绘画所有功能及风格模型"
            ],
            vip_tab: [{
                id: 1,
                title: '月度套餐'
            }, {
                id: 2,
                title: '季度套餐（8折）'
            }, {
                id: 3,
                title: '年卡套餐（6折）'
            }],
            active_vip_tab: 0,
            vip_list: [{
                id: 1,
                name: '基础会员',
                tips: '体验套餐，适合新手入门',
                month_price: '68',
                quarter_price: '88',
                desc: ['赠送绘画<span>720积分（全站功能通用）</span>', '积分可生成<span>720次</span>普通模式图', '赠送绘画<span>720积分（全站功能通用）</span>', '积分可生成<span>720次</span>普通模式图', '赠送绘画<span>720积分（全站功能通用）</span>']
            }, {
                id: 2,
                name: '基础会员',
                tips: '体验套餐，适合新手入门',
                month_price: '68',
                quarter_price: '88',
                desc: ['赠送绘画<span>720积分（全站功能通用）</span>', '赠送绘画<span>720积分（全站功能通用）</span>', '积分可生成<span>720次</span>普通模式图', '赠送绘画<span>720积分（全站功能通用）</span>', '积分可生成<span>720次</span>普通模式图']
            }, {
                id: 3,
                name: '基础会员',
                tips: '体验套餐，适合新手入门',
                month_price: '68',
                quarter_price: '88',
                desc: ['赠送绘画<span>720积分（全站功能通用）</span>', '赠送绘画<span>720积分（全站功能通用）</span>', '积分可生成<span>720次</span>普通模式图', '赠送绘画<span>720积分（全站功能通用）</span>', '积分可生成<span>720次</span>普通模式图']
            },],
            timerout:false,
            payTimer:null,
            pay_time:0,
            payVip:{
                id: 3,
                name: '基础会员',
                tips: '体验套餐，适合新手入门',
                month_price: '68',
                quarter_price: '88',
                desc: ['赠送绘画<span>720积分（全站功能通用）</span>', '赠送绘画<span>720积分（全站功能通用）</span>', '积分可生成<span>720次</span>普通模式图', '赠送绘画<span>720积分（全站功能通用）</span>', '积分可生成<span>720次</span>普通模式图']
            }
        }
    },
    created() {

    },
    computed: {
        userInfo() {
            return this.$store.state.userInfo;
        },
        isLogin() {
            return this.$store.state.isLogin;
        }
    },
    watch: {
        '$store.state.show_open_compoments': function (val) {
            this.dialogVisible = val;
        }
    },
    methods: {
        choose_tab(index) {
            this.active_vip_tab = index
        },
        close() {
            this.$store.commit('setShowOpen', false)
        },
        handleShowQuestion() {
            this.$store.commit('setShowQuestion', true)
        },
        getPayInfo(){
            this.timerout = false;
            this.payTimer = setInterval(() => {
                // this.$http.get(`/pay/order/status/?uniq_key=${uniq_key}`).then((res) => {
                //     if (res.data.code == 1) {
                //         this.$message({
                //             message: '升级会员成功！',
                //             type: 'success'
                //         });
                //         clearInterval(this.payTimer);
                //         this.payTimer = null;
                //         this.pay_time = 0;
                //         // this.fetchProfile()
                //     }
                // })
                this.pay_time = 0;
                this.pay_time += 3;
                if(this.pay_time >= 60*30){
                    this.pay_time = 0;
                    clearInterval(this.payTimer);
                    this.payTimer = null;
                    this.timerout = true;
                }
            }, 3000)
        }
    },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.centerPanel {
    display: flex;
    width: 1200px;
    height: 700px;
    font-size: 14px;
    .aside{
        width: 280px;
        background-image: url("./img/member-left.png");
        padding-top: 177px;
        padding-left: 36px;
        color: #fff;
        font-size: 12px;
        line-height: 30px;
        .advantage{
            white-space: nowrap;
            overflow: hidden;
            padding-right: 12px;
            text-overflow: ellipsis;
            display: flex;
            align-items: center;
            .el-icon-check{
                margin-right: 8px;
                font-size: 16px;
                margin-top: 2px;
            }
        }
    }
    .con {
        padding: 30px 40px 0;
        background-color: #fff;
        overflow: hidden;
        flex: 1 1 0%;
        user-select: none;
        height: 100%;
        position: relative;
        line-height: 1;

        .top_right{
            position: absolute;
            top: 18px;
            right: 20px;
            display: flex;
            align-items: center;
            .issue{
                cursor: pointer;
                margin-top: 4px;
                &:hover{
                    color: #333;
                }
                .el-icon-info{
                    font-size: 14px;
                }
            }
            .el-icon-close{
                font-size: 18px;
                font-weight: bold;
                cursor: pointer;
                margin-top: 2px;
                &:hover{
                    color: #333;
                }
            }
        }

        .full {
            width: 100%;
            height: 100%;

            .user_info{
                display: flex;
                align-items: center;
                color: #42414a;
                .avatar{
                    width: 50px;
                    height: 50px;
                    margin-right: 12px;
                    border-radius: 25px;
                    border: none;
                }
                .info_right{
                    display: flex;
                    flex-direction: column;
                    .user_name{
                        font-weight: bold;
                    }
                    .info_detail{
                        font-size: 12px;
                        margin-top: 8px;
                    }
                }
            }

            .vip_tab {
                height: 48px;
                margin-top: 26px;
                padding: 3px;
                border-radius: 6px;
                background-color: #f1f1f7;
                justify-content: space-around;
                width: 100%;
                display: flex;
                align-items: center;

                .vip_tab_item {
                    cursor: pointer;
                    border-radius: 6px;
                    flex: 1 1 0%;
                    height: 100%;

                    &.active {
                        font-weight: 700;
                        color: #fff;
                        background-color: #5865f2;
                    }
                }
            }

            .tab_con {
                display: flex;
                justify-content: space-between;
                margin-top: 22px;

                .vip_list {
                    border-radius: 14px;
                    width: 266px;
                    padding: 25px 22px;
                    color: #42414a;
                    border: 2px solid #f0f0f0;
                    cursor: pointer;
                    &.active{
                        background-color: rgba(88, 101, 242, 0.08);
                        border-color: #5865f2;
                    }

                    .name {
                        font-size: 16px;
                        font-weight: bold;
                    }

                    .tips {
                        margin: 8px 0 10px;
                        font-size: 12px;
                        color: #7d7c82;
                    }

                    .price {
                        display: flex;
                        align-items: flex-end;
                        justify-content: space-between;
                        margin: 15px 0 12px;

                        .quarter_price {
                            font-size: 24px;
                            color: #ff3737;
                            font-weight: bold;
                        }

                        .month_price {
                            font-size: 12px;
                            color: #707173;
                        }
                    }

                    .split_line{
                        height: 1px;
                        margin: 22px 0 18px;
                        background-color: #e1e1ff;
                        width: 100%;
                    }

                    .vip_desc {
                        display: flex;
                        flex-direction: column;

                        .vip_desc_item {
                            display: flex;
                            align-items: center;
                            font-size: 13px;
                            margin-bottom: 18px;

                            i {
                                display: block;
                                width: 6px;
                                height: 6px;
                                background: #5865F2;
                                border-radius: 50%;
                                margin-right: 5px;
                                flex-shrink: 0;
                            }

                            /deep/p {
                                span {
                                    color: #5865F2;
                                    font-weight: bold;
                                }
                            }

                            &:last-child {
                                border-bottom: 0;
                                margin-bottom: 0;
                            }
                        }
                    }
                }
            }

            .pay_bottom{
                margin-top: 24px;
                padding: 28px;
                background-color: #f9f9f9;
                border-radius: 10px;
                display: flex;
                align-items: center;
                .pay_code{
                    width: 134px;
                    height: 134px;
                    position: relative;
                    border: 1px solid;
                    .code_img{
                        width: 100%;
                        height: 100%;
                    }
                    .time_out_cover{
                        position: absolute;
                        width: 100%;
                        height: 100%;
                        top: 0;
                        left: 0;
                        z-index: 2;
                        color: #fff;
                        background-color: rgba(0, 0, 0, 0.56);
                        cursor: pointer;
                        &:hover{
                            font-size: 15px;
                        }
                    }
                }
                .pay_right{
                    font-size: 12px;
                    margin-left: 16px;
                    .pay_money{
                        font-size: 13px;
                        .money_count{
                            font-size: 24px;
                            margin-left: -3px;
                            font-weight: bold;
                            color: #ff3737;
                        }
                    }
                    .pay_tips{
                        margin: 15px 0;
                        height: 34px;
                        display: flex;
                        align-items: center;
                        .wx_icon{
                            width: 18px;
                            height: 18px;
                            margin-right: 6px;
                            border: none;
                        }
                    }
                    .agreement{
                        color: #9e9e9e;
                        a{
                            color: #9e9e9e;
                        }
                    }
                }
            }
            
        }
    }
}
</style>